import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Investors from "@/pages/Investors";
import BlogList from "@/pages/BlogList";
import BlogPostPage from "@/pages/BlogPostPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";

const Smooth = ({ children }) => (
  <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
    {children}
  </ReactLenis>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<Smooth><Home /></Smooth>} />
          <Route path="/about" element={<Smooth><About /></Smooth>} />
          <Route path="/investors" element={<Smooth><Investors /></Smooth>} />
          <Route path="/blog" element={<Smooth><BlogList /></Smooth>} />
          <Route path="/blog/:slug" element={<Smooth><BlogPostPage /></Smooth>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
